
import { defineComponent, ref, onMounted, toRef } from "vue";
import { themeName, demo } from "@/core/helpers/documentation";

export default defineComponent({
  name: "responded-chargeback-details",
  props: {
    chargeback: Object,
    incomings: Array,
  },
  setup(props) {
    const input2 = ref("");
    const connections = ref([]);
    onMounted(() => {
      const chargeback = toRef(props, "chargeback");
    });
    return {
      themeName,
      input2,
      demo,
      connections,
    };
  },
});
